<template>
  <custom-callout border-color-hex="#FF7058" class="my-3" :has-toggle="false">
    <validation-observer ref="createContractFormRef" v-slot="{}" tag="form">
      <div class="my-2">
        <icon-view
          class="ml-n1"
          :gradient="false"
          icon="fas fa-file-signature ml-1"
          icon-background="#fff"
          icon-color="#fe7159"
          icon-size="16px"
          title="Crear Contrato"
        />
      </div>
      <div class="row py-2 pr-4 pb-4">
        <div class="col-12 col-md-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.academicYear"
              custom-error-msg="El año académico es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Año Académico:"
              :options="academicYears"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.contractType"
              custom-error-msg="El tipo de contrato es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Tipo de Contrato:"
              :options="contractTypes"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div
          class="col-12 mt-2 pt-2 d-flex align-items-center justify-content-end"
        >
          <action-button
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-4"
            @click="handleCancel"
          />
          <action-button
            i="fas fa-arrow-alt-circle-right"
            text="Continuar"
            variant="success pl-3 pr-3"
            @click="handleContinue"
          />
        </div>
      </div>
    </validation-observer>
  </custom-callout>
</template>

<script>
// libs
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';

export default {
  name: 'CreateContract',
  components: {
    CustomCallout,
    ActionButton,
    CustomDropDown,
    IconView,
  },
  props: {
    academicYears: {
      type: Array,
      default: () => [],
    },
    contractTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: {
        academicYear: undefined,
        contractType: undefined,
      },
    };
  },
  methods: {
    handleCancel() {
      this.$emit('on-cancel');
    },
    async handleContinue() {
      const isValid = await this.$refs.createContractFormRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      this.$emit('on-continue', { ...this.model });
    },
  },
};
</script>
